import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
}

const Footer = ({ onClose }: Props) => {
  return (
    <>
      <Button type="secondary" onClick={onClose}>
        {i18n.t('common.cancel')}
      </Button>
      <Button submit>{i18n.t('common.delete')}</Button>
    </>
  )
}

export { Footer }
